import React from "react";
import FormsyEditorBase from "components/ExtraAttributes/EditorControl/FormsyEditorBase";
import RelativeDatePicker from "components/DocListFilterModal/RelativeDatePicker";

const RelativeDateEditorControl = (props) => (
    <FormsyEditorBase
        required={props.isRequired ? "isDefaultRequiredValue" : undefined}
        render={(value, changeValue) => (
            <RelativeDatePicker
                index={props.index}
                value={value || ""}
                onChange={
                    /* istanbul ignore next */ (e) => {
                        if (e.currentTarget.value === "NotSet")
                            changeValue({ currentTarget: { value: null } });
                        else changeValue(e);
                    }
                }
                style={props.style}
                className={props.className}
            />
        )}
        {...props}
    />
);
RelativeDateEditorControl.displayName = "RelativeDateEditorControl";
export default RelativeDateEditorControl;
